<style lang="scss" scoped>
@import "details";
.search-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
	.el-form-item {
		margin-bottom: 0;
	}
}
.record-details {
	display: flex;
	align-items: center;
	.title {
		width: 150px;
		min-height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	dl {
		flex: 1;
		border-left: 1px solid #e4e6ea;
		dd {
			padding: 12px 0;
			border-bottom: 1px solid #e4e6ea;
			&:last-child {
				border: 0;
			}
		}
	}
}
</style>
<style lang="scss">
.user-details .el-table__expanded-cell[class*="cell"] {
	padding: 0 !important;
}
.cons{
  display: none;
}
@media screen and (max-width: 640px){
  .container{
    width: 90% !important;
    font-size: 12px!important;
  }
  .con{
    display: none!important;
  }
  .cons{
    display: block!important;
  }
  .text-lists {
    display: block!important;
  }
  .text-lists li {
    width: 100% !important;
  }
  .container h3.title {
    font-size: 20px !important;
  }
}
</style>
<template>
	<div class="user-details">
		<section class="container">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/user' }"
					>用户中心</el-breadcrumb-item
				>
				<el-breadcrumb-item
					><router-link to="/user/sanger"
						>测序订单</router-link
					></el-breadcrumb-item
				>
				<el-breadcrumb-item>测序订单详情</el-breadcrumb-item>
			</el-breadcrumb>
			<h3 class="title">Sanger测序订单详情<span :style="{fontSize: '14px', marginLeft: '20px', cursor: 'pointer'}"><a @click="viewContract">《服务协议》</a></span></h3>
			<ul class="text-lists">
				<li v-show="isHeadMan">
					<span>关联用户：</span>{{ details.customerName }}
				</li>
				<li><span>订单创建者：</span>{{ details.createUserName }}</li>
				<li>
					<span>整单返样：</span
					>{{ details.value&&details.value.orderReturnFlag ? "是" : "否" }}
				</li>
				<li><span>实验基地：</span>{{ details.baseName }}</li>
				<li>
					<span>订单创建时间：</span
					>{{ details.value&&details.value.createTime | rTime }}
				</li>
				<li><span>收货地址：</span>{{ address }}</li>
			</ul>
      
      <div style="margin-top: 10px;">注：客户应自收到发票之日起3个月内支付费用，双方有其他约定的以另行约定为准</div>
			<el-table
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
        class="mt20" border :data="orderTable">
				<el-table-column prop="no" width="200" label="订单编号"> </el-table-column>
				<el-table-column label="下单时间" width="160">
					<template slot-scope="scope">{{
						scope.row.createTime | rTime
					}}</template>
				</el-table-column>
				<el-table-column prop="totalNum" label="反应总数">
				</el-table-column>
				<el-table-column prop="okNum" label="成功反应数">
				</el-table-column>
        <el-table-column prop="webFreeNum" label="免费反应数">
				</el-table-column>
        <el-table-column prop="settlementNum" label="成功计费反应数">
				</el-table-column>
        <el-table-column prop="failAndPayNum" label="失败计费反应数">
				</el-table-column>
				<!-- <el-table-column prop="settlementNum" label="计费反应数">
				</el-table-column> -->
				<el-table-column label="订单金额（元）" width="120">
					<template slot-scope="scope">{{
						scope.row.settlementAmount | amount
					}}</template>
				</el-table-column>
				<el-table-column prop="orderStatusName" label="订单状态">
				</el-table-column>
				<el-table-column prop="settlementStatusName" label="结算状态" >
				</el-table-column>
        <el-table-column prop="unlockPoints" label="已解锁积分" >
        </el-table-column>
        <el-table-column
          prop="lockPoints"
          width="120"
          label="未解锁积分">
          <template slot="header">
            <span>未解锁积分</span>
            <el-tooltip class="item" effect="dark" content="本次赠送积分，以最终订单结算为准" placement="top">
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            {{scope.row.lockPoints}}
          </template>
        </el-table-column>
<!--				<el-table-column label="结算后获取积分" width="140">-->
<!--					<template slot-scope="scope">{{-->
<!--						scope.row.integralNumber | tableNone-->
<!--					}}</template>-->
<!--				</el-table-column>-->
				<el-table-column prop="returnStatusName" label="返样状态">
				</el-table-column>
			</el-table>
			<h3 class="title">订单包含反应信息</h3>
			<div class="search-top con">
				<el-form
					:inline="true"
					:model="searchForm"
					class="demo-form-inline"
				>
					<el-form-item label="样品名称：">
						<el-input
							v-model="searchForm.demoName"
							placeholder="请输入样品名称"
						></el-input>
					</el-form-item>
					<el-form-item label="引物名称：">
						<el-input
							v-model="searchForm.primerName"
							placeholder="请输入引物名称"
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="bindSearch"
							>搜索</el-button
						>
					</el-form-item>
				</el-form>
				<div class="download">
					<a class="pointer mr20" @click="getWorkerDoc"
						><span class="el-icon-download"></span>结果下载</a
					>
					<a class="pointer" @click="getDetailsExcel"
						><span class="el-icon-download"></span>明细表下载</a
					>
				</div>
			</div>
      <div class="cons">
        <div class="search-top">
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline"
          >
            <el-form-item label="样品名称：" style="margin-bottom: 10px;">
              <el-input
                v-model="searchForm.demoName"
                placeholder="请输入样品名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="引物名称：">
              <el-input
                v-model="searchForm.primerName"
                placeholder="请输入订单号"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="bindSearch"
              >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="download" style="margin-top: 10px;">
          <a class="pointer mr20" @click="getWorkerDoc"
          ><span class="el-icon-download"></span>结果下载</a
          >
          <a class="pointer" @click="getDetailsExcel"
          ><span class="el-icon-download"></span>明细表下载</a
          >
        </div>
      </div>
			<el-table
				border
				class="mt20"
        :header-cell-style="{
          background:'#f7f9fa',
          color: '#4e5051',
          textAlign: 'center'
        }"
        :cell-style="{
          textAlign: 'center'
        }"
				:data="reactionLists"
				@selection-change="handleSelectionChange"
			>
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column
					prop="value.no"
					width="240"
					label="反应工单号"
				>
				</el-table-column>
				<el-table-column prop="value.demo.name" label="样品名称">
				</el-table-column>
				<el-table-column prop="value.demoType" label="样品类型">
				</el-table-column>
				<el-table-column
					prop="value.demo.appraisalStatus"
					label="鉴定状态"
				>
				</el-table-column>
				<el-table-column prop="value.primer.name" label="引物名称">
				</el-table-column>
				<el-table-column prop="value.testResultName" label="测通结果">
				</el-table-column>
				<el-table-column
					prop="value.reactionStatusName"
					label="反应状态"
				>
				</el-table-column>
				<el-table-column
					prop="value.reactionlTypeName"
					label="反应类型"
				>
				</el-table-column>
				<el-table-column prop="value.returnStatusName" label="返样状态">
				</el-table-column>
				<el-table-column
					label="返样类型"
				>
          <template slot-scope="scope">
            {{getReturnDemoStatus(scope.row.value.demo.returnDemoStatus)}}
          </template>
				</el-table-column>

<!--				<el-table-column-->
<!--					prop="value.demo.returnDemoRemark"-->
<!--					label="返样备注"-->
<!--				>-->
<!--				</el-table-column>-->

				<el-table-column label="计费类型" width="100">
					<template slot-scope="scope">
            <span>{{formatChargeType(scope.row.value)}}</span>
						<!-- <img
							src="@/assets/images/icon_check3.png"
							v-if="scope.row.value.chargeType === 'S'"
						/>
						<span v-else>免费</span> -->
						<!--            <img src="@/assets/images/icon_check3_disable.png">-->
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<!-- <span
							class="text-primary pointer"
							@click="bindReturnExample(scope.row.value)"
							v-if="
								scope.row.value.demo.userReturnDemoStatus ===
								'NO' && scope.row.value.demo.appraisalStatusType&&
                scope.row.value.demo.appraisalStatusType!='RESHAKE'&&
                scope.row.value.demo.appraisalStatusType!='PAUSE'
							"
							>返样</span
						>

						<span v-else class="text-gray9" style="cursor: pointer;" @click="noClick(scope.row.value.demo.appraisalStatusType)">返样</span>
					 -->          
           <span
           v-if="scope.row.value.demo.appraisalStatusType=='RESHAKE'
           ||scope.row.value.demo.appraisalStatusType=='PAUSE'
           ||!scope.row.value.demo.appraisalStatusType
           ||scope.row.value.demo.userReturnDemoStatus=='ING'
           ||scope.row.value.demo.userReturnDemoStatus=='OK'
           "
           class="text-gray9" style="cursor: pointer;"
            @click="noClick(scope.row.value.demo.appraisalStatusType,scope.row.value.demo.userReturnDemoStatus)">返样</span>

           <span v-else
           class="text-primary pointer"
           @click="bindReturnExample(scope.row.value)">返样</span>

          </template>
				</el-table-column>
			</el-table>
			<div class="page tr">
				<el-pagination
					:page-size="10"
					:pager-count="10"
					layout="total, sizes, prev, pager, next"
          :page-sizes="[10, 20, 50, 100, 200, 500]"
					:total="reactionTotal"
          @size-change="changeSize"
					@current-change="changePage"
				>
				</el-pagination>
			</div>
			<h3
				class="title distribution-title"
				@click="showDistribution = !showDistribution"
			>
				配送记录<span
					class="el-icon-arrow-down"
					:class="{ active: !showDistribution }"
				></span>
			</h3>
			<div v-show="showDistribution">
				<el-table :data="sendLists" border>
					<el-table-column type="expand">
						<template slot-scope="scope">
							<div class="record-details">
								<div class="title">样品名称</div>
								<dl>
									<dd
										v-for="item in scope.row.items"
										:key="item.id"
									>
										{{ item.goodsName }}
									</dd>
								</dl>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="配送单号" prop="code">
					</el-table-column>
					<el-table-column prop="sendStatusName" label="配送状态">
					</el-table-column>
					<el-table-column label="配送方式" prop="sendTypeName">
					</el-table-column>
					<el-table-column label="配送员/运单号">
						<template slot-scope="scope">
							<div v-if="scope.row.sendType === 'SENDER'">
								{{
									scope.row.sender &&
									scope.row.sender.realName
								}}
							</div>
							<div v-else>{{ scope.row.deliveryCode }}</div>
							<!--              <div v-if="scope.row.sender">-->
							<!--                {{scope.row.sender.realName}}/{{scope.row.deliveryCode}}-->
							<!--              </div>-->
						</template>
					</el-table-column>
					<el-table-column label="配送完成时间">
						<template slot-scope="scope">{{
							scope.row.finishSendDate | rTime
						}}</template>
					</el-table-column>
				</el-table>
				<div class="page tr">
					<el-pagination
						:page-size="10"
						:pager-count="10"
						layout="prev, pager, next"
						:total="sendTotal"
						@current-change="changeSendPage"
					>
					</el-pagination>
				</div>
			</div>
		</section>

		<el-dialog title="返样" :visible.sync="visible" width="480px" >
			<el-form
				:model="form"
				:rules="rules"
				label-width="80px"
				size="small"
			>
				<el-form-item label="返样要求" prop="returnDemoStatus">
					<el-select
						v-model="form.returnDemoStatus"
						placeholder="请选择返样要求"
					>
						<el-option
							v-for="(item, index) in returnDemoStatusMap"
							:key="index"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="返样备注">
					<el-input
						type="textarea"
						v-model="form.returnDemoRemark"
						placeholder="请输入备注"
					></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="visible = false"
					>取 消</el-button
				>
				<el-button size="small" type="primary" @click="handleReturnDemo"
					>确 定</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
  sequencingOrdersDetails,
  sequencingReaction,
  sendOrders,
  returnExample,
  sangerExcel,
  sangerWorderDoc,
  sangerSettlement,
  peakDown
} from '@/services/api.index'

import {
  tableHeaderStyle,
  tableCellStyle
} from '@/settings/table'

export default {
  data() {
    return {
      tableHeaderStyle,
      tableCellStyle,
      visible: false,
      form: {
        returnDemoStatus: '',
        returnDemoRemark: ''
      },
      rules: {
        returnDemoStatus: [{ required: true, message: '请选择' }]
      },
      row: {}, // 要返样的行数据
      returnDemoStatusMap: [
        {
          label: 'PCR',
          value: '是-PCR'
        },
        {
          label: '菌液',
          value: '是-A'
        },
        {
          label: '质粒',
          value: '是-B'
        },
        {
          label: '平板',
          value: '是-C'
        },
        {
          label: '菌液/质粒',
          value: '是-A/B'
        },
        {
          label: '质粒/平板',
          value: '是-B/C'
        },
        {
          label: '菌液/平板',
          value: '是-A/C'
        },
        {
          label: '菌液/质粒/平板',
          value: '是-A/B/C'
        }
      ],

      searchForm: {
        primerName: '',
        demoName: ''
      },
      id: this.$route.query.id,
      details: {},
      address: '',
      orderTable: [],
      reactionLists: [],
      reactionTotal: 0,
      reactionPage: 0,
      reactionSize: 10,
      sendLists: [],
      sendTotal: 0,
      sendPage: 0,
      sendSize: 10,
      showDistribution: true,
      multipleSelection: [],
      isHeadMan: this.baseMethods.isHeadMan()
    }
  },
  created() {
    this.getDetails()
    this.getReaction()
  },
  methods: {
    formatChargeType({ chargeType, status, reactionStatusName }) {
      // if(['ING', 'PAUSE', 'CLOSE'].includes(status)){
      //   return ''
      // }
      // const { freeFlag } = this.details.value||{};
      // if(freeFlag || status === 'F'){
      //   return `${reactionStatusName},不收费`
      // }
      const chargeTypes = { S: '成功计费', F: '免费', SF: '成功失败均计费' }
      return `${chargeTypes[chargeType]}`
    },
    getReturnDemoStatus(returnDemoStatus) {
      let status = this.returnDemoStatusMap.find(v => v.value === returnDemoStatus)
      return status ? status.label : '否'
    },
    viewContract() {
      window.open(process.env.SHOP_URL + `/article/detail/14_0`)
    },
    // 订单详情
    getDetails() {
      sequencingOrdersDetails(this.id).then((res) => {
        this.details = res.data
        let returnStatusName
        switch (res.data.userWebreturnDemoStatus) {
          case 1:
            returnStatusName = '未返样'
            break
          case 2:
            returnStatusName = '部分返样'
            break
          case 3:
            returnStatusName = '全部返样'
            break
        }
        res.data.value.returnStatusName = returnStatusName
        let value = res.data.value
        value.orderStatusName = this.baseMethods.orderStatus(
          res.data.userWebOrderStatus
        )
        value.settlementStatusName = this.baseMethods.settlementStatus(
          value.settlementStatus
        )
        this.address = value.raProvince
          ? `${value.raProvince}${value.raCity}${value.raCounty} ${value.raAddress}`
          : ''
        this.getSendOrders()
        this.getSettlement(value)
      })
    },
    getSettlement(value) {
      sangerSettlement(this.id).then((res) => {
        console.info('settlement', res.data)
        this.orderTable = this.orderTable.concat(
          Object.assign(value, res.data)
        )
      })
    },
    bindSearch() {
      this.reactionPage = 0
      this.getReaction()
    },
    // 订单包含反应信息
    getReaction() {
      const { reactionPage, reactionSize } = this
      const { demoName, primerName } = this.searchForm
      sequencingReaction(
        this.id,
        reactionPage,
        reactionSize,
        demoName,
        primerName
      ).then((res) => {
        res.data.list.map((item) => {
          // debugger
          item.value.reactionStatusName = this.baseMethods.reactionStatus(
            item.value.status
          )
          item.value.reactionlTypeName = this.baseMethods.reactionType(
            item.value.reactionlType
          )
          if (item.value.demo.plate.type === 'E') {
            item.value.demo.appraisalStatus = this.baseMethods.appraisalStatus3(
              item.value.demo.appraisalStatus
            )
          } else {
            item.value.demo.appraisalStatus = this.baseMethods.appraisalStatus1(
              item.value.demo.appraisalStatus
            )
          }

          item.value.returnStatusName = this.baseMethods.returnStatus(
            item.value.demo.userReturnDemoStatus
          )
          item.value.testResultName = this.baseMethods.testResult(
            item.value.demo.result
          )
          item.value.demoType = this.baseMethods.demoType(
            item.value.demo.plate.type
          )
        })
        this.reactionLists = res.data.list
        this.reactionTotal = res.data.totalCount
      })
    },
    // 配送记录
    getSendOrders() {
      const { sendPage, sendSize, details } = this
      sendOrders(sendPage, sendSize, details.value.no).then((res) => {
        res.data.map((item) => {
          item.sendStatusName = this.baseMethods.sendStatus(
            item.sendStatus,
            'sanger'
          )
          item.sendTypeName = this.baseMethods.sendType(
            item.sendType
          )
        })
        this.sendLists = res.data
        this.sendTotal = this.baseMethods.getTotal(res)
      })
    },
    // 反应信息多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 返样
    bindReturnExample(row) {
      console.log(row, '[[row]]')
      this.row = { ...row }
      if (row.status === 'ING') {
        this.$confirm(
          '正在反应中的样品不建议返还，确认返还样品？',
          '样品返还'
        ).then(() => {
          this.visible = true
          this.form.returnDemoStatus = ''
          this.form.returnDemoRemark = ''
        })
      } else {
        this.visible = true
        this.form.returnDemoStatus = ''
        this.form.returnDemoRemark = ''
      }
    },

    handleReturnDemo() {
      let params = [
        {
          id: this.row.demo.id,
          ...this.form
        }
      ]
      if (!this.form.returnDemoStatus) {
        return;
      }

      returnExample(params).then(() => {
        this.$message.success('返样成功')
        this.visible = false
        this.getReaction()
      })
    },
    // 明细表下载
    getDetailsExcel() {
      if (!this.id) {
        return;
      }
      sangerExcel(this.id).then((res) => {
        this.baseMethods.downloadFile(res.data, '明细表')
      })
    },
    // 工单下载
    getWorkerDoc() {
      const { multipleSelection } = this
      if (multipleSelection.length === 0) {
        return this.$message.warning('请选择需要下载的工单')
      }
      if (multipleSelection.length > 1) {
        let ids = []
        multipleSelection.map((item) => {
          ids.push(item.value.id)
        })
        sangerWorderDoc(ids).then((res) => {
          this.baseMethods.downloadFile(
            res.data,
            '测序工单结果',
            'doc'
          )
        })
      } else {
        const id = multipleSelection[0].value.id
        peakDown(id).then((res) => {
          const data = res.data
          this.baseMethods.courseDownload(data.ossUrl, data.name)
        })
      }
    },
    // 翻页
    changePage(value) {
      this.reactionPage = value - 1
      this.getReaction()
    },
    changeSize (value) {
      this.reactionSize = value
      this.getReaction()
    },
    changeSendPage(value) {
      this.sendPage = value - 1
      this.getSendOrders()
    },
		noClick(item,status) {      
			if(!item) return this.$message.warning("该样品还未进行鉴定，不可进行返样操作，请耐心等待!");
      if(item=="RESHAKE"||item=="PAUSE") return this.$message.warning("该样品还未进行鉴定，不可进行返样操作，请耐心等待!");
      if(status=="OK") return this.$message.warning("该样品已完成返样");
      if(status=="ING") return this.$message.warning("该样品正在返样中");
    }
  }
}
</script>
<style>
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .el-dialog{
    width: 90%!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/sanger_details.vue